import Vue from 'vue'
import store from '../store'
import vueClipboard from 'vue-clipboard2'
import autocompleteIndexedDB from '@/utils/autocompleteIndexedDB'
import { i18n } from '@/i18n'
// import _ from 'lodash'
// import router from './router'
Vue.use(vueClipboard)

Vue.directive('required', {
  bind (el, binding) {
    const {type, message} = binding.value
    el.addEventListener(type, () => {
      if (!el.value) {
        el.nextElementSibling.innerText = window.vm.$t(message)
      } else {
        el.nextElementSibling.innerText = ''
      }
    }, false)
  },
})

function permission (el, binding) {
  const permission = store.getters['home/permissionList']
  if (permission.length === 0) return false
  const {value, arg} = binding
  if (value === '') return false
  // permission['site:running:render:task:sheduled'] = {}
  // permission['site:running:render:task:sheduled'].status = true
  if (!permission[value] || !permission[value].status) {
    arg === 'show' ? el.style.display = 'none' : el.remove()
  }
}

Vue.directive('permission', {
  inserted (el, binding) {
    permission(el, binding)
  },
  update (el, binding) {
    permission(el, binding)
  },
})

Vue.directive('btnScrollFixed', {
  inserted (el, binding) {
    const scrollBody = document.querySelector('.el-main')
    const header = document.querySelector('.el-header')
    const fixeTop = el.offsetTop - 50
    el.classList.add('content-fixed')
    function scrollCB () {
      console.log(el)
      // scrollBody.removeEventListener('scroll', scrollCB)
      // return _.throttle(() => {
      if (scrollBody.scrollTop >= fixeTop) {
        header.classList.add('fixed-bottom')
        el.classList.add('btn-box-fixed')
      } else {
        header.classList.remove('fixed-bottom')
        el.classList.remove('btn-box-fixed')
      }
      // }, 100)
    }
    scrollBody.addEventListener('scroll', scrollCB)
    function destoryScroll () {
      console.log('ccc')
      // scrollBody.removeEventListener('scroll', scrollCB)
    }
    window.__destoryScroll__ = destoryScroll
  },
})

Vue.directive('autocomplete', {
  inserted (el, {value, arg}, vnode) {
    const find = Array.prototype.find
    const {name} = vnode.context.$route
    const componentKey = `${name}_${arg ? `${arg}${value}` : value}`
    const limitLen = 10
    const inputDom = find.call(el.childNodes, v => v.tagName === 'INPUT')
    let result, pullDown

    inputDom.addEventListener('focus', async e => {
      result = await autocompleteIndexedDB.get(componentKey)
      if (result && result.keyWord && result.keyWord.length > 0) {
        let fragment = document.createDocumentFragment()
        pullDown = document.createElement('div')
        pullDown.style.width = `${el.offsetWidth}px`
        pullDown.className = 'autocomplete-box'
        result.keyWord.forEach(v => {
          let listDiv = document.createElement('div')
          listDiv.className = 'autocomplete-list'
          listDiv.textContent = v

          const closeIcon = document.createElement('span')
          closeIcon.className = 'el-icon-circle-close'
          closeIcon.dataset.value = v

          const listItem = document.createElement('div')
          listItem.className = 'autocomplete-item'
          listItem.appendChild(listDiv)
          listItem.appendChild(closeIcon)

          pullDown.appendChild(listItem)
        })
        const clearAll = document.createElement('div')
        clearAll.className = 'autocomplete-clear-all-item'
        clearAll.textContent = i18n.t('common_clear_history')
        clearAll.dataset.value = 'clear-all'
        pullDown.appendChild(clearAll)
        // blur比click事件先触发，为了确保dom不被remove
        setTimeout(_ => {
          fragment.appendChild(pullDown)
          el.appendChild(fragment)
        }, 150)

        pullDown.addEventListener('click', e => {
          let target = e.target
          if (target.className === 'autocomplete-list') {
            vnode.context[value] = target.textContent
          }
          pullDownDestroy()
        })
        let pullDownDestroy = function () {
          let boxDom = document.querySelector('.autocomplete-box')
          document.removeEventListener('click', hideHandle)
          boxDom && boxDom.remove()
        }

        let hideHandle = function (e) {
          let target = e.target
          if (!el.contains(target) && !pullDown.contains(target)) {
            pullDownDestroy()
          }
        }
        document.addEventListener('click', hideHandle)
      }
    })

    const removeItem = (e) => {
      const removeValue = e.target.dataset.value
      if (removeValue) {
        if (removeValue === 'clear-all') {
          result.keyWord = []
          autocompleteIndexedDB.edit(result)
          return
        }
        result.keyWord.splice(result.keyWord.indexOf(removeValue), 1)
        autocompleteIndexedDB.edit(result)
      }
    }
    el.addEventListener('click', removeItem)

    vnode.context.eventBusOn('updateAutocompleteDB', _ => {
      const value = inputDom.value
      if (value === '') return false
      if (result) {
        if (result.keyWord.includes(value)) {
          result.keyWord.splice(result.keyWord.indexOf(value), 1)
          result.keyWord.unshift(value)
        } else {
          result.keyWord.unshift(value)
          if (result.keyWord.length > limitLen) {
            result.keyWord.pop()
          }
        }
        autocompleteIndexedDB.edit(result)
      } else {
        autocompleteIndexedDB.add({
          componentKey: componentKey,
          keyWord: [value],
        })
      }
    })
  },
})

Vue.directive('displayBranch', {
  inserted (el, binding) {
    if (!binding.value) el.innerHTML = binding.value
    else el.innerHTML = binding.value.replace(/,/g, ',<br>')
  },
  update (el, binding) {
    if (!binding.value) el.innerHTML = binding.value
    else el.innerHTML = binding.value.replace(/,/g, ',<br>')
  },
})

Vue.directive('binaryAdminId', {
  inserted (el, { value }) {
    const COLOR_OBJ = Object.freeze({
      Empty: 'transparent',
      Code: '#c0c4cc',
    })
    const { width = '100%', height = '100%', rotate = 'to bottom' } = value || {}
    const {userInfo} = store.state['home']
    const adminId = userInfo.id
    const adminIdBinaryList = adminId ? Array.from(adminId.toString(2)) : []
    // 空白位占一份，0值占一份，1值占两份
    let colorList = [COLOR_OBJ.Empty]
    adminIdBinaryList.forEach(value => {
      switch (value) {
        case '1': {
          colorList.push(COLOR_OBJ.Code, COLOR_OBJ.Code)
          break
        }
        case '0': {
          colorList.push(COLOR_OBJ.Code)
          break
        }
      }
      colorList.push(COLOR_OBJ.Empty)
    })
    colorList = colorList.slice(1, -1)
    const colorListLength = colorList.length
    if (colorListLength === 0) {
      return
    }
    const piecePercent = (100 / colorListLength).toFixed(2)
    const lineGradient = `linear-gradient(${rotate}, ${colorList.map((color, index) => `${color} ${index * piecePercent}% ${(index + 1) * piecePercent}%`)})`
    el.style.backgroundImage = lineGradient
    el.style.backgroundSize = `${width} ${height}`
  },
})

Vue.directive('hover', {
  bind(el, binding) {
    el.addEventListener('mouseenter', () => {
      binding.value(true)
    })
    el.addEventListener('mouseleave', () => {
      binding.value(false)
    })
  },
})
